import { render } from "./UiCheck.vue?vue&type=template&id=09b4e5fa&scoped=true"
import script from "./UiCheck.vue?vue&type=script&lang=js"
export * from "./UiCheck.vue?vue&type=script&lang=js"

import "./UiCheck.vue?vue&type=style&index=0&id=09b4e5fa&scoped=true&lang=css"

import exportComponent from "/Users/cole/.codex/worktrees/jwt-cookie-expiry/tcd-cube_opr/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09b4e5fa"]])

export default __exports__